export const HOME_PAGE = '/';
export const CREATE_FAIR_PAGE = '/create-fair';
export const HALLS = '/halls';
export const FAIRS_DETAILS = '/fair-details';
export const FLOOR_DRAWING = '/floor';
export const DEVICE = '/device';
export const FLOOR_PLANS_BASE = '/floor-plans-base';

